export class ClaimPermissionsFailure {
    static readonly type = '[User] ClaimPermissionsFailure';
}
